import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25Icons } from "../s25-icon/s25.icon.const";

@TypeManagerDecorator("s25-ng-collapse-chevron")
@Component({
    selector: "s25-ng-collapse-chevron",
    template: `
        <s25-ng-icon
            [style.--icon--rotation-degrees]="rotationDegrees()"
            [type]="iconProp()"
            [size]="size()"
            [ariaLabel]="label() ? label() : expanded() ? 'Collapse' : 'Expand'"
        />
    `,
    styles: `
        :host {
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }

        ::ng-deep s25-ng-icon {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25IconComponent],
})
export class S25CollapseChevronComponent {
    readonly collapsedOrientation = input<"right" | "down" | undefined>(); // set collapsed position to pointing right (list items, etc) or down (panel type view)
    readonly size = input<number>();
    readonly expanded = input(false);
    readonly label = input<string>();

    protected readonly iconProp = computed<Extract<S25Icons.Name, "caretRight" | "caretDown">>(() =>
        this.collapsedOrientation() === "right" ? "caretRight" : "caretDown",
    );

    protected readonly rotationDegrees = computed(() => {
        if (!this.expanded()) return "0deg";
        return this.collapsedOrientation() === "right" ? "90deg" : "180deg";
    });
}
